// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/**************************************************/
/*            DataTable Header                    */
/**************************************************/
.TableHeaderCell {
  display: flex;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.TableHeaderDiv {
    height: 100%;
    min-height: 1px;
}
/*.TableHeaderCell:hover .ng-resizable-handle {
    background-color: black;
    display: block;
  }*/
.TableHeaderCellContent {
    align-self: center;
    /* padding: 3px 10px;*/
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.Sticky {
  position: sticky;
  background-color: white;
  z-index: 2;
}


.CellContentRow > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.CellContentRow > .CellContentRowText {
    flex-direction: row;
}

.cellOperator {
    padding-right: 10px;
}

.redColor {
    color: red;
}

.greenColor {
    color: green;
}
/**********************************************************/
/*                  SpreadSheet                           */
/**********************************************************/
.SpreadSheetHeaderCellContent {
  align-self: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.SpreadSheetHeaderCell {
    display: flex;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border: 1px solid var(--spreadsheet-line);
    border-bottom: 2px double var(--spreadsheet-line);
}

  /*.SpreadSheetHeaderCell:hover .ng-resizable-handle {
    background-color: black;
    display: block;
  }*/

/**********************************************************/
/*                  Resize & Select                       */
/**********************************************************/
.ng-resizable-handle:hover {
  background-color: black;
  display: block;
}

.showResize .ng-resizable-handle {
  background-color: black;
  display: block;
}

.selectedRow {
    background-color: var(--primary-color) !important;
    color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/components/datatable/header.column.container.css"],"names":[],"mappings":";AACA,mDAAmD;AACnD,mDAAmD;AACnD,mDAAmD;AACnD;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;;;IAGI;AACJ;IACI,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;AACZ;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;AACA,2DAA2D;AAC3D,2DAA2D;AAC3D,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,yCAAyC;IACzC,iDAAiD;AACrD;;EAEE;;;IAGE;;AAEJ,2DAA2D;AAC3D,2DAA2D;AAC3D,2DAA2D;AAC3D;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;IACI,iDAAiD;IACjD,YAAY;AAChB","sourcesContent":["\n/**************************************************/\n/*            DataTable Header                    */\n/**************************************************/\n.TableHeaderCell {\n  display: flex;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.TableHeaderDiv {\n    height: 100%;\n    min-height: 1px;\n}\n/*.TableHeaderCell:hover .ng-resizable-handle {\n    background-color: black;\n    display: block;\n  }*/\n.TableHeaderCellContent {\n    align-self: center;\n    /* padding: 3px 10px;*/\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n.Sticky {\n  position: -webkit-sticky;\n  position: sticky;\n  background-color: white;\n  z-index: 2;\n}\n\n\n.CellContentRow > div {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n}\n\n.CellContentRow > .CellContentRowText {\n    flex-direction: row;\n}\n\n.cellOperator {\n    padding-right: 10px;\n}\n\n.redColor {\n    color: red;\n}\n\n.greenColor {\n    color: green;\n}\n/**********************************************************/\n/*                  SpreadSheet                           */\n/**********************************************************/\n.SpreadSheetHeaderCellContent {\n  align-self: center;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.SpreadSheetHeaderCell {\n    display: flex;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    border: 1px solid var(--spreadsheet-line);\n    border-bottom: 2px double var(--spreadsheet-line);\n}\n\n  /*.SpreadSheetHeaderCell:hover .ng-resizable-handle {\n    background-color: black;\n    display: block;\n  }*/\n\n/**********************************************************/\n/*                  Resize & Select                       */\n/**********************************************************/\n.ng-resizable-handle:hover {\n  background-color: black;\n  display: block;\n}\n\n.showResize .ng-resizable-handle {\n  background-color: black;\n  display: block;\n}\n\n.selectedRow {\n    background-color: var(--primary-color) !important;\n    color: white;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
